import React from 'react'

import { useFormContext } from 'react-hook-form'
import { FormattedMessage } from 'react-intl'
import { useSelector } from 'react-redux'

import Price from '@components/UI/Price/Price'
import { IApplicationState } from '@store'
import {
  selectAmountCurrency,
  selectTransactedBrandedContentAd,
  selectTransactedBrandedContentAdAmountCents,
  selectTransactedBrandedContentAdAmountCurrency,
} from '@store/submissions'
import Theme from '@theme'
import { Container, H4, TextField } from '@tribegroup'
import { isEmpty } from '@utils'

interface IProps {
  submissionId: number
}

const PlannedSpend: React.FC<IProps> = ({ submissionId }) => {
  const { register } = useFormContext()
  const amount = useSelector((state: IApplicationState) =>
    selectTransactedBrandedContentAdAmountCents(state, submissionId),
  )
  const savedCurrency = useSelector((state: IApplicationState) =>
    selectTransactedBrandedContentAdAmountCurrency(state, submissionId),
  )
  const defaultCurrency = useSelector((state: IApplicationState) =>
    selectAmountCurrency(state, submissionId),
  )
  const transactedBrandedContentAd = useSelector((state: IApplicationState) =>
    selectTransactedBrandedContentAd(state, submissionId),
  )
  const isEditable = isEmpty(transactedBrandedContentAd)
  if (!isEditable) {
    return (
      <Container bottomInnerSpacing={0.5} topInnerSpacing={0.5}>
        <H4 color={Theme.grey900Color}>
          <Price currency={savedCurrency} quantity={amount} rounded />
        </H4>
      </Container>
    )
  }

  return (
    <React.Fragment>
      <Container absolute topOuterSpacing={0.6}>
        <H4 color={Theme.grey900Color}>
          <FormattedMessage id={`core.currency.symbol.${defaultCurrency}`} />
        </H4>
      </Container>
      <TextField
        data-testid="planned-spend-input"
        quiet
        fullWidth
        autoFocus
        type="number"
        scheme="default"
        leftPadding={1}
        fontSize={1.125}
        defaultValue={amount}
        {...(({ ref, ...rest }) => ({ ...rest, innerRef: ref }))(
          register('planned_spend_amount', { required: true, min: 1 }),
        )}
      />
    </React.Fragment>
  )
}

export { PlannedSpend }
export default PlannedSpend
